/**
 * Search Bar Vue Component
 * ------------------------------------------------------------------------------
 * Template in snippets/header-search.liquid
 *
 */

import axios from 'axios'
import debounce from 'lodash-es/debounce'
import Cookies from 'js-cookie'

import { useFlyouts } from '@/js/composables/flyouts'
import KeenSlider from '@/js/components/keen-slider.vue'
import { transformGraphqlProduct, searchProductsRequest } from '@/js/utils/data'
import { storefrontRequestConfig, STOREFRONT_URL } from '@/js/utils/api'

export default {
  components: {
    KeenSlider
  },

  props: {
    defaultValue: {
      type: String,
      default: null
    }
  },

  setup () {
    const {
      flyouts,
      toggleFlyout
    } = useFlyouts()

    return {
      flyouts,
      toggleFlyout
    }
  },

  data () {
    return {
      isSearchLoading: false,
      search: this.defaultValue,
      filteredProducts: [],
      results: []
    }
  },

  computed: {
    currentState () {
      return Cookies.get('state') || 'NSW' // used to filter products based on the available inventory in a location
    }
  },

  watch: { // Debounce and watchers - https://vuejs.org/v2/guide/computed.html#Watchers
    search (value) {
      if (value) {
        this.performSearch()
      } else {
        this.results = []
      }
    },

    flyouts: {
      handler (value) {
        if (value.search) {
          this.$nextTick(() => {
            this.$refs.search.focus()
          })

          if (this.search && !this.results.product?.length) this.performSearch()
        }
      },
      deep: true
    }
  },

  methods: {
    performSearch: debounce(async function () {
      this.isSearchLoading = true

      if (this.search) {
        this.filterProducts()
        // Predictive Search API - https://shopify.dev/docs/themes/ajax-api/reference/predictive-search
        axios.get(`/search/suggest.json?q=${this.search}&resources[limit]=10`).then(({ data }) => {
          this.results = data.resources.results
          console.log('Results:', this.results)
        }).catch((error) => {
          console.log(error)
        }).finally(() => {
          this.$nextTick(() => {
            this.isSearchLoading = false
          })
        })
      }
    }, 500),

    async filterProducts () {
      const metarequestBody = searchProductsRequest(this.search, 'first: 50, sortKey: RELEVANCE')
      axios.post(STOREFRONT_URL, metarequestBody, storefrontRequestConfig).then(async ({ data, config }) => {
        this.filteredProducts = []
        const products = data.data.search.edges
        if (data) {
          products.forEach((product) => {
            let productItem = {}
            productItem = transformGraphqlProduct(product.node)

            // check if the current state value is ACT
            if (this.currentState === 'ACT') {
            // If the state is ACT, include products from both ACT and NSW warehouses
              if (productItem.available_on?.includes(this.currentState) || productItem.available_on?.includes('NSW')) {
              // set the formatted product
                this.filteredProducts.push(productItem)
              }
            } else {
            // check the state value (from the Cookie) and match if the selected state has an available inventory in the product
              if (productItem.available_on?.includes(this.currentState)) {
              // set the formatted product
                this.filteredProducts.push(productItem)
              }
            }
          })
        }
      })
    }
  }
}
